export type ynType = 'Y' | 'N';

export enum CrudConstant {
  C = "C",
  R = "R",
  U = "U",
  D = "D"
}

export const BltnbClCd = {
  NOTICE: "NOTICE",
  FAQ: "FAQ",
  QNA: "QNA",
  API: "API",
} as const;
export type BltnbClType = typeof BltnbClCd[keyof typeof BltnbClCd];

export const PrstsCd = {
  PROCESS : "PROCESS",
  CONFIRM: "CONFIRM",
  REJECT: "REJECT",
  COMPLETE: "COMPLETE",
} as const;
export type PrstsCdType = typeof PrstsCd[keyof typeof PrstsCd];

export interface CommonCode {
  ComUnit: { value: number, label: string }[];
  EmksCntrKndCd: { value: string, label: string }[];
  EmksCustTpClCd: { value: number, label: string }[];
  EmksEntClCd: { value: string, label: string }[];
  EmksEqpKndCd: { value: number, label: string }[];
  EmksIndsCmplxClCd: { value: string, label: string }[];
  EmksLdspTrdClCd: {value: number, label: string}[];
  EmksMbrsClCd: { code: number, name: string }[];
  EmksPrtclKndCd: { value: number, label: string }[];
  EmksRe100JoinClCd: { value: number, label: string }[];
  EmksRsrcClCd: { value: number, label: string, path: string | undefined }[];
  MobileNumberPrefix: { value: string, label: string }[];
}